import React from 'react';
import imports from '@/routing/imports';
import { pickModule } from '@/common/lazy/Loadable';

const TicketDetail = React.lazy(() => imports.mytickets().then(pickModule('TicketDetail')));
const TicketDetailSubscriber = React.lazy(() => imports.mytickets().then(pickModule('TicketDetailSubscriber')));

export const SuspendedTicketDetail = props => (
    <React.Suspense fallback={null}>
        <TicketDetail {...props} />
    </React.Suspense>
);

export const SuspendedTicketDetailSubscriber = props => (
    <React.Suspense fallback={null}>
        <TicketDetailSubscriber {...props} />
    </React.Suspense>
);
